import { Link } from "react-router-dom";
import React from "react";

type LinkType = { href: any; children: any };
export default function MdLink({ href, children }: LinkType) {
  return <Link to={href}>{children}</Link>;
}
